window.clearInput = function(th) {
    th.closest(".has-float-label").find("[name]").val("").change().focus();
}
window.show_hide_clear_input = function(th) {
    var p = th.closest(".has-float-label");
    if (th.val()) {
        p.addClass("has-val");
    } else {
        p.removeClass("has-val");
    }
}

$(function() {
    /**
     * показываем скрываем кнопку-крестик (типа "очистить поле")
     * ессли поле в фокусе и в нем есть данные
     * */
    $(".has-float-label input").on("keyup keydown", function() {window.show_hide_clear_input($(this));});

    /**
     * при клике на кнопку "очистить поле"
     * */
    $(".has-float-label .clear-svg").on("click", function() {window.clearInput($(this))});

    $(".has-float-label .show-pass").on("click", function() {
        var th = $(this);
        var p = th.closest(".has-float-label");
        p.find("[name]").attr("type", "text");
        th.addClass("d-none");
        p.find(".hide-pass").removeClass("d-none");
    });

    $(".has-float-label .hide-pass").on("click", function() {
        var th = $(this);
        var p = th.closest(".has-float-label");
        p.find("[name]").attr("type", "password");
        th.addClass("d-none");
        p.find(".show-pass").removeClass("d-none");
    });

    /**
     *
     *
     *
     *
     *
     *
     *
     *
     *
     *
     * */

    $("body").on("click", ".minus_count", function() {
        var input = $(this).closest(".plus-minus-wrap").find("input[type]");
        var val = $.trim(input.val());
        if (!val || val == '') {
            val = 0;
        }
        val = parseInt(val);
        val--;
        if (val < 0) {
            val = 0;
        }
        input.val(val);
    });

    $("body").on("click", ".plus_count", function() {
        var input = $(this).closest(".plus-minus-wrap").find("input[type]");
        var val = $.trim(input.val());
        if (!val || val == '') {
            val = 0;
        }
        val = parseInt(val);
        val++;

        input.val(val);
    });
});
